<template>
  <div class="dashboard-container">
    <h2>赛事会员数据导出</h2>
    <el-form label-width="96px">
      <el-form-item label="选择联赛">
        <el-select v-model="match" filterable value-key="name" placeholder="请选择" @change="selectMatch" >
          <el-option
            v-for="item in matchList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择组别">
        <el-select v-model="group" filterable value-key="name" placeholder="请选择" >
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="导出数据" >
        <el-button @click="exportData" :disabled="!match.id || !group.id">导出数据</el-button>
      </el-form-item>
    </el-form>

    <h2>注册会员数据导出</h2>
    <el-form label-width="96px">
      <el-form-item label="选择会员类型">
        <el-select v-model="memberType" filterable value-key="name" placeholder="请选择">
          <el-option
            v-for="item in memberTypeList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="导出数据" >
        <el-button @click="exportMemberData" :disabled="!memberType">导出数据</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import _ from 'lodash'
import { getMatchList, getMatchGroupList, exportMatchData, exportCoaches, exportInFieldReferees,
  exportOutFieldReferees, exportOrganizations, exportPlayers} from '@/api/match'

export default {
  name: 'StatsExportList',
  data() {
    return {
      match: {},
      matchId: null,
      matchList: [],
      group: {},
      groupList: [],
      memberTypeList: [
        {id: 1, name: '运动员', type: 'player'},
        {id: 2, name: '教练员', type: 'coach'},
        {id: 3, name: '场内裁判员', type: 'in-referee'},
        {id: 4, name: '场外裁判员', type: 'out-referee'},
        {id: 0, name: '会员单位', type: 'member'}
      ],
      memberType: null
    }
  },
  created() {
    this.getMatchList()
  },
  computed: {
  },
  methods: {
    getMatchList() {
      const params = {
        pageSize: 9999,
        out: 0,
        status: 0
      }
      getMatchList(params).then((resolve) => {
        this.matchList = resolve.data.list
      })
    },
    selectMatch(match) {
      getMatchGroupList({ matchId: match.id, pageSize: 9999 }).then((resolve) => {
        this.group = {}
        this.groupList = resolve.data.list
        this.groupList = _.filter(this.groupList, function (item) {
            return item.status == 0
          })
        })
    },
    exportData() {
      let params = {
        matchId: this.match.id
      }
      if(this.group && this.group.id) {
        params.groupId = this.group.id
      }
      if (params.matchId && !this.group.id) {
        this.$message({
          message: '组别必须要选择',
          type: 'info',
          showClose: true,
          duration: 1000
        })
        return
      }
      exportMatchData(params).then((resolve) => {
        const data = resolve.data
        if(data && data.url) {
          window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
          this.$message({
            message: '导出数据成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    },
    exportMemberData() {
      if (this.memberType && this.memberType.id === 1) {
        let params = {
          matchId: this.match.id
        }
        if(this.group && this.group.id) {
          params.groupId = this.group.id
        }
        exportPlayers(params).then((resolve) => {
          const data = resolve.data
          if(data && data.email) {
            this.$message({
              message: '导出数据成功，请在邮箱:' + data.email + '查收',
              type: 'success',
              showClose: true,
              duration: 2000
            })
          }
        })
      } else if (this.memberType && this.memberType.id === 2) {
        exportCoaches().then((resolve) => {
          const data = resolve.data
          if(data && data.url) {
            window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
            this.$message({
              message: '导出数据成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
          }
        })
      } else if (this.memberType && this.memberType.id === 3) {
        exportInFieldReferees().then((resolve) => {
          const data = resolve.data
          if(data && data.url) {
          window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
          this.$message({
            message: '导出数据成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
      } else if (this.memberType && this.memberType.id === 4) {
        exportOutFieldReferees().then((resolve) => {
          const data = resolve.data
          if(data && data.url) {
          window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
          this.$message({
            message: '导出数据成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
      } else if (this.memberType && this.memberType.id === 0) {
        exportOrganizations().then((resolve) => {
          const data = resolve.data
          if(data && data.url) {
          window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
          this.$message({
            message: '导出数据成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
